var $ = jQuery;
$(document).ready(function ($) {
    // Get URL parameters using the URLSearchParams API
    let urlParams = new URLSearchParams(window.location.search);

    // Get the current path of the page
    let urlPath = window.location.pathname;

    // Check if specific query parameters ('title', 'category', 'order') are present in the URL
    // or if the URL path contains '/page/' (indicating pagination)
    if (urlParams.has('title') 
        || urlParams.has('category') 
        || urlParams.has('order') 
        || urlPath.includes('/page/')) {
        
        // Find the HTML element with the ID 'all_news'
        let anchor = document.getElementById('all_news');

        // If the element exists, scroll to it smoothly and align it to the top of the viewport
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    // Navigation
    $('#header_search_trigger').on('click', function(){
        $('#header_search_form').addClass('active');
    })
    $('#s').attr('placeholder', 'Search');

    // Navigation responsive
    $('#menu_trigger').on('click', function(){
        $('.navigation-wrapper').toggleClass('active');
        $('body').toggleClass('overflow-hidden')
    })

    $('li.menu-item-has-children').on('click', function (event) {
        if ($(event.target).is('a, ul')) {
            return;
        }

        $(this).toggleClass('show_sub_menu');
    });



    // blk-news-list
    if ($('.blk-news-list').length > 0) {
        const filterForm = $('.blk-news-list form');
        const newsList = $('.blk-news-list');
    
        // Function to handle form submission
        const triggerFormSubmit = () => filterForm.trigger('submit');
    
        // Attach click event to the search icon
        newsList.find('.icon-search').on('click', triggerFormSubmit);
    
        // Attach change events to relevant dropdowns
        newsList.find('#category-select, #sort-by').on('change', triggerFormSubmit);
    }

    // blk-media
    $('.blk-media-play').on('click', function() {
        $video_url = $(this).attr('data-url');
        $(this).hide();
        $(this).siblings('img').hide();
        $(this).siblings('iframe').attr('src', $video_url).show();
    });

    // blk-hero-navigation
    if ($('.blk-hero-navigation').length > 0) {
        $('.blk-hero-navigation .navigation-item').each(function() {
            $(this).on('mouseover', function() {
                $(this).siblings('.navigation-item').removeClass('active');
                $(this).addClass('active');
            });
        });
    }   
    
    // blk-timeline
    if ($('.blk-timeline').length > 0) {
        $('.blk-timeline .swiper-button-next').on('click', function () {
            const container = $(this).closest('.blk-timeline').find('.timeline_style_class')[0];
            container.scrollTo({
                left: container.scrollLeft + container.clientWidth / 2,
                behavior: "smooth"
            });
        });
    
        $('.blk-timeline .swiper-button-prev').on('click', function () {
            const container = $(this).closest('.blk-timeline').find('.timeline_style_class')[0];
            container.scrollTo({
                left: container.scrollLeft - container.clientWidth / 2,
                behavior: "smooth"
            });
        });
    }  

    // notification-bar
    if ($('.notification_bar').length > 0) {
        $('#closeNotificationBar').on('click', function () {
            $('.notification_bar').fadeOut(300, function () {
                $(this).remove();
                $('html').removeClass('has_notification_bar');
            });
        });
    }
});

$(window).on('resize', function() {
});

$(window).on('click', function(event) {
    if (!event.target.closest('#header_search')) {
        $('#header_search_form').removeClass('active');
    }
});

$(window).on('scroll', function() {
});